export default __webpack_public_path__ + "static/media/qrscananimation.82baf9a8.gif";